<template>
  <div class="game-info-user">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/game-manage' }">游戏管理</el-breadcrumb-item>
      <el-breadcrumb-item><a @click="goOff()">详情 （{{game_name}}）</a></el-breadcrumb-item>
      <el-breadcrumb-item>用户记录 （{{user_name}}）</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="list">
      <el-table
        :data="tableData.data"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        size="small"
      >
        <template v-for=" (game_item, index) in tableData.game_pages_CHN_list">
          <el-table-column
            fixed
            :prop="game_item"
            :label="keyName(game_item)" v-if="index === 0">
          </el-table-column>
          <el-table-column
            :prop="game_item"
            :label="keyName(game_item)" v-else>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>


<script>
    export default {
        data() {
            return {
                user_name: decodeURI(this.$route.query.user_name),
                game_name: decodeURI(this.$route.query.game_name),
                pages:1,
                limit: 10,
                key: '',
                tableData: [],
                total:0,
            }
        },
        methods: {
            getList(){
                this.$get('/v1/admin/users-game-record?user_id=' + this.$route.query.user_id+ '&gameId=' + this.$route.query.game_id, {})
                    .then((res) => {
                        if (res.data.status === 'success') {
                            this.tableData = res.data.data;
                            this.total = res.data.data.total;
                        } else {
                            this.$msg(res.data.msg)
                        }
                    });
            },
            keyName(key){
                return this.tableData.game_pages_CHN[key]
            },
            tableRowClassName({row, rowIndex}) {
                if (rowIndex %2 === 1) {
                    return '';
                } else {
                    return 'success-row';
                }
            },
            handleSizeChange(val) {
                this.limit = val;
                this.getList()
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.pages = val;
                this.getList()
                console.log(`当前页: ${val}`);
            },
            goTo(path,user_id,game_name){
                this.$router.push({
                    path:path,
                    query:{
                        name:this.$route.query.name,
                        user_id:user_id,
                        game_name:encodeURI(game_name)
                    }
                })
            },
            goOff(){
                this.$router.go(-1);
            },
        },
        created() {
            this.getList()
        }
    }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .game-info-user
    .el-table .warning-row {
      background: oldlace;
    }

    .el-table .success-row {
      background: #f0f9eb;
    }
    .search
      margin 20px 0
      display flex
      justify-content space-between
      >div
        display flex
        justify-content flex-start
        input
          width 200px
          margin-right 20px
    .list
      min-height 550px
      margin-top 20px
      border 1px solid #EBEEF5
    .block
      margin-top:10px;
    .time-screen
      display flex
      justify-content space-between
      flex-wrap wrap
      >span
        cursor pointer
      >.el-date-editor
        wdith:100%;
        margin 20px 0 0;

    ::-webkit-scrollbar {
      display:block;
    }
    .el-table {
      .el-table__fixed,.el-table__fixed-right {
        height:auto !important;
        bottom:17px !important;
      }
    }
    //去掉固定列下方的横线
    .el-table__fixed::before, .el-table__fixed-right::before {
      display: none;
    }

</style>



// WEBPACK FOOTER //
// src/pages/GameManage/GameInfoUser.vue